<template>
  <div class="v-spinner">
    <div class="v-square">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SquareLoader',
};
</script>

<style>
.v-spinner .v-square
{
    -webkit-animation: v-squareDelay 3s 0s infinite cubic-bezier(.09,.57,.49,.9);
    animation: v-squareDelay 3s 0s infinite cubic-bezier(.09,.57,.49,.9);
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    perspective: 100px;
    display: inline-block;
    height: 50px;
    width: 50px;
    background-color: #6BBBAE;
    padding: 16px 8px;
    color: white;
    letter-spacing: 2px;
}
@-webkit-keyframes v-squareDelay
{
    25%
    {
        -webkit-transform: rotateX(180deg) rotateY(0);
                transform: rotateX(180deg) rotateY(0);
    }
    50%
    {
        -webkit-transform: rotateX(180deg) rotateY(180deg);
                transform: rotateX(180deg) rotateY(180deg);
    }
    75%
    {
        -webkit-transform: rotateX(0) rotateY(180deg);
                transform: rotateX(0) rotateY(180deg);
    }
    100%
    {
        -webkit-transform: rotateX(0) rotateY(0);
                transform: rotateX(0) rotateY(0);
    }
}
@keyframes v-squareDelay
{
    25%
    {
        -webkit-transform: rotateX(180deg) rotateY(0);
                transform: rotateX(180deg) rotateY(0);
    }
    50%
    {
        -webkit-transform: rotateX(180deg) rotateY(180deg);
                transform: rotateX(180deg) rotateY(180deg);
    }
    75%
    {
        -webkit-transform: rotateX(0) rotateY(180deg);
                transform: rotateX(0) rotateY(180deg);
    }
    100%
    {
        -webkit-transform: rotateX(0) rotateY(0);
                transform: rotateX(0) rotateY(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SquareLoader.vue